<template>
	<div class="d-flex flex-column gap-2" :class="isXS ? 'height-full justify-center' : ''">
		<Icon
			class="align-self-center text-primary-900"
			:class="iconClass"
			:icon="icon"
			radius="54px"
		/>
		<h3 class="text-neutral-900 text-align-center">
			{{ title }}
		</h3>
		<p class="text-body-xl text-neutral-900 text-align-center">
			{{ description }}
		</p>
	</div>
	<PButton class="request-help-button mt-6" size="lg" @click="$emit('click')">
		{{ buttonText }}
	</PButton>
</template>

<script setup lang="ts">
	interface Props {
		title: string
		description: string
		icon: string
		buttonText: string
		isXS: boolean
		iconClass?: string
	}
	defineProps<Props>()
	defineEmits(['click'])
</script>
<style lang="scss" scoped>
	.request-help-button {
		width: 100%;
	}
</style>
